var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Home"}},[_c('h1',[_vm._v("HOME")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/power-scan"}},[_vm._v("PowerScan")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }